import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-17" }, null, -1)
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_7 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Status", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Total dos Serviços", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Deduções", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "ISS", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "ISS Retido", -1)
const _hoisted_25 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Total da Nota", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("b", null, "Sim", -1)
const _hoisted_29 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_38 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_natureza_operacao = _resolveComponent("selecionar-natureza-operacao")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_nota_fiscal_servico_itens = _resolveComponent("nota-fiscal-servico-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_servico_impostos = _resolveComponent("nota-fiscal-servico-impostos")!
  const _component_nota_fiscal_servico_detalhes_pagamento = _resolveComponent("nota-fiscal-servico-detalhes-pagamento")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-fiscal' : 'scroll-modal ss-modal-fiscal'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Nota Fiscal de Serviço")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            ((_ctx.state.notaFiscalServico.codigo > 0))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.state.notaFiscalServico.status === _ctx.EStatusNotaFiscalServico.Autorizada)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: "Cancelar"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            style: {"display":"none"},
                            type: "button",
                            class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                          }, [
                            _createVNode(_component_icone, { nome: "cancelar" })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.notaFiscalServico.status === _ctx.EStatusNotaFiscalServico.Pendente)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 1,
                        placement: "top",
                        title: "Excluir"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                          }, [
                            _createVNode(_component_icone, { nome: "excluir" })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            ((_ctx.state.notaFiscalServico.codigo > 0 && !_ctx.UtilitarioGeral.valorValido(_ctx.state.notaFiscalServico.identificador) && _ctx.state.notaFiscalServico.status === _ctx.EStatusNotaFiscalServico.Pendente))
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 1,
                  placement: "top",
                  title: "Emitir NFS-e"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      style: {"display":"none"},
                      type: "button",
                      class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitir && _ctx.emitir(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "check" })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ((_ctx.state.editavel))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvar()))
                }, _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  style: _normalizeStyle('color: white; font-size: 11px; background-color: ' + _ctx.obterCorStatus(_ctx.state.notaFiscalServico.status) + '!important;'),
                  value: _ctx.obterDescricaoStatus(_ctx.state.notaFiscalServico.status),
                  disabled: "true"
                }, null, 12, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscalServico.totalServicos, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscalServico.totalDesconto, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_16)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscalServico.totalDeducoes, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_19)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscalServico.totalImpostos.totalIss, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_campo_numerico, {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscalServico.totalImpostos.totalIssRetido, 2, true),
                  disabled: "true"
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  style: {"background-color":"#000066","color":"white","font-weight":"bolder"},
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscalServico.totalNotaFiscal, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_27)
              ])
            ])
          ]),
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              (_ctx.state.editavel && _ctx.state.recuperarSalvamentoAutomatico)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui uma versão mais recente desta nota fiscal de serviço salvo de forma automática, deseja recuperar? "),
                      _createVNode(_component_a_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.recuperarSalvamentoAutomatico())),
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.state.notaFiscalServico.numero > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_card, { titulo: "DOCUMENTO FISCAL" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_a_form_item, {
                                label: "Nº NFS-e",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    style: {"text-align":"right"},
                                    min: "0",
                                    type: "number",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.notaFiscalServico.numero) = $event)),
                                    disabled: true
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.notaFiscalServico.numero]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_a_form_item, {
                                label: "Data de Autorização",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    "hora-minuto-segundo": true,
                                    dataSelecionada: _ctx.state.notaFiscalServico.dataEmissao,
                                    "onUpdate:dataSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.notaFiscalServico.dataEmissao) = $event)),
                                    disabled: true
                                  }, null, 8, ["dataSelecionada"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_a_form_item, {
                                label: "Chave",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.notaFiscalServico.chave) = $event)),
                                    disabled: true
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.notaFiscalServico.chave]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_a_form_item, {
                                label: "Nº RPS",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    style: {"text-align":"right"},
                                    min: "0",
                                    type: "number",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.notaFiscalServico.numeroRps) = $event)),
                                    disabled: true
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.notaFiscalServico.numeroRps]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_a_form_item, {
                                label: "Data de Competência",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    "hora-minuto-segundo": true,
                                    dataSelecionada: _ctx.state.notaFiscalServico.dataCompetencia,
                                    "onUpdate:dataSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.notaFiscalServico.dataCompetencia) = $event)),
                                    disabled: !_ctx.state.editavel,
                                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.salvamentoAutomatico()))
                                  }, null, 8, ["dataSelecionada", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_a_form_item, {
                                label: "Natureza Operação",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_natureza_operacao, {
                                    valor: _ctx.state.notaFiscalServico.naturezaOperacao,
                                    "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.notaFiscalServico.naturezaOperacao) = $event)),
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, ["valor", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_card, { titulo: "RPS" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_a_form_item, {
                                label: "Nº RPS",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    style: {"text-align":"right"},
                                    min: "0",
                                    type: "number",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.notaFiscalServico.numeroRps) = $event)),
                                    disabled: true
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.notaFiscalServico.numeroRps]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_a_form_item, {
                                label: "Série",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.notaFiscalServico.serieRps) = $event)),
                                    disabled: !_ctx.state.editavel,
                                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.salvamentoAutomatico()))
                                  }, null, 40, _hoisted_43), [
                                    [_vModelText, _ctx.state.notaFiscalServico.serieRps]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_a_form_item, {
                                label: "Data de Emissão",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    "hora-minuto-segundo": true,
                                    dataSelecionada: _ctx.state.notaFiscalServico.dataEmissaoRps,
                                    "onUpdate:dataSelecionada": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.notaFiscalServico.dataEmissaoRps) = $event)),
                                    disabled: !_ctx.state.editavel,
                                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.salvamentoAutomatico()))
                                  }, null, 8, ["dataSelecionada", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_a_form_item, {
                                label: "Data de Competência",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    "hora-minuto-segundo": true,
                                    dataSelecionada: _ctx.state.notaFiscalServico.dataCompetencia,
                                    "onUpdate:dataSelecionada": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.notaFiscalServico.dataCompetencia) = $event)),
                                    disabled: !_ctx.state.editavel,
                                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.salvamentoAutomatico()))
                                  }, null, 8, ["dataSelecionada", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_a_form_item, {
                                label: "Natureza Operação",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_natureza_operacao, {
                                    valor: _ctx.state.notaFiscalServico.naturezaOperacao,
                                    "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.notaFiscalServico.naturezaOperacao) = $event)),
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, ["valor", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])),
              _createVNode(_component_card, { titulo: "TOMADOR" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_selecionar_pessoa, {
                        codigoSelecionado: _ctx.state.notaFiscalServico.tomador.codigoPessoa,
                        "onUpdate:codigoSelecionado": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.notaFiscalServico.tomador.codigoPessoa) = $event)),
                        empresas: [_ctx.state.notaFiscalServico.codigoEmpresa],
                        recursoOrigem: "NOTA_FISCAL_SERVICO",
                        disabled: !_ctx.state.editavel
                      }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "SERVIÇOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_servico_itens, {
                            "regime-tributario": _ctx.state.notaFiscalServico.prestador.regimeTributario,
                            empresa: _ctx.state.notaFiscalServico.codigoEmpresa,
                            "obrigar-principal": true,
                            editavel: _ctx.state.editavel,
                            itens: _ctx.state.notaFiscalServico.servicos,
                            "onUpdate:itens": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.notaFiscalServico.servicos) = $event)),
                            onAtualizarValores: _ctx.atualizarValoresTotais,
                            onAtualizarLocalPrestacao: _ctx.atualizarLocalPrestacao
                          }, null, 8, ["regime-tributario", "empresa", "editavel", "itens", "onAtualizarValores", "onAtualizarLocalPrestacao"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "2",
                        tab: "IMPOSTOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_servico_impostos, {
                            impostos: _ctx.state.notaFiscalServico.totalImpostos,
                            "onUpdate:impostos": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.notaFiscalServico.totalImpostos) = $event)),
                            onTotalAlterado: _ctx.atualizarValoresTotais,
                            editavel: false
                          }, null, 8, ["impostos", "onTotalAlterado"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "3",
                        tab: "PAGAMENTO"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_nota_fiscal_servico_detalhes_pagamento, {
                            empresa: _ctx.state.notaFiscalServico.codigoEmpresa,
                            totalDetalhesPagamento: _ctx.state.totalDetalhesPagamento,
                            "onUpdate:totalDetalhesPagamento": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.totalDetalhesPagamento) = $event)),
                            detalhesPagamento: _ctx.state.notaFiscalServico.detalhesPagamento,
                            "onUpdate:detalhesPagamento": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.notaFiscalServico.detalhesPagamento) = $event)),
                            editavel: _ctx.state.editavel,
                            onAtualizarDetalhePagamento: _ctx.atualizarTotalDetalhesPagamento
                          }, null, 8, ["empresa", "totalDetalhesPagamento", "detalhesPagamento", "editavel", "onAtualizarDetalhePagamento"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}